import { CodedProperty } from "sprint-common-web";

import { LanguageLookupItemResponse } from "../api/admin-api/GetLanguagesLookupResponse";

export type Language = CodedProperty;

export const mapToLanguage = (response: LanguageLookupItemResponse): Language => ({
    id: response.id,
    name: response.name,
    code: response.code
});

export const getLanguageDisplayName = (language: Language): string => {
    return `${language.name} (${language.code})`;
};
